module.exports = __webpack_public_path__ + "media/images/tl/banner/en-light-pc-86e5673a87423c6445a29f849edcb563.jpg";